import { Button } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';

type Props = {
  handleClick: () => void;
};

export const TopUpButton = ({ handleClick }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Button
      onClick={handleClick}
      text={t('wallet.topUp.button')}
      fit="content"
      data-testid="top-up-wallet-button"
      variant="primaryBrand"
      iconName="plus"
      iconPosition="left"
    />
  );
};
